import { render, staticRenderFns } from "./setEducation.vue?vue&type=template&id=634d36b2&"
import script from "./setEducation.vue?vue&type=script&lang=js&"
export * from "./setEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports